import React from "react";
import CustomSelect from "./CustomSelect";

const KeyDropdownValue = (props) => {
  const {
    title,
    leftIcon,
    rightIcon,
    error,
    hint,
    disabled,
    ...rest
  } = props;
  return (
    <div id={`key-dropdown-value-${props.name}`} className="gl-input">
      {title ? <div id={`title-container-${props.name}`} className="title">{title}</div>: null}
      <div
        className={`select-wrapper ${error ? "error" : ""} ${
          disabled ? "disabled" : ""
        }`}
      >
        <CustomSelect
          rightIcon={rightIcon}
          leftIcon={leftIcon}
          aria-errormessage={`error-container-${props.name}`}
          aria-describedby={`hint-container-${props.name}`}
          aria-labelledby={`title-container-${props.name}`}
          aria-label={title}
          aria-invalid={!!error}
          {...rest}
        />
      </div>
      {hint && (
        <div id={`hint-container-${props.name}`} className="hint-container">
          <p className="hint">{hint.join(" ")}</p>
        </div>
      )}
      {error && (
        <div id={`error-container-${props.name}`} className="error-container">
          <p className="error">{error.join(" ")}</p>
        </div>
      )}
    </div>
  );
};
export default KeyDropdownValue;
